module.exports = "data:text/csv;base64,UHJvZHVjdCBOYW1lLFByb2R1Y3QgRGVzY3JpcHRpb24sUGFsbGV0IERpbWVuc2lvbnMsV2lkdGggLExlbmd0aCxIZWlnaHQsV2VpZ2h0LENsYXNzLFBhbGxldHMgU3RhY2thYmxlCnRlc3QsUGF5bWVudCBDaGFubmVsICwxLDQ4LDQ4LDUwLDUwLDUwLHllcwo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/product_import_template.csv
// module id = 9EJt
// module chunks = 1